import React, { Component } from 'react';
import '../settings.css';
import TagsByInput from '../../TagsAndChips/TagsByInput';
import { showNotification } from '../../../StatusNotification';

export class FormSettings extends Component {
    static displayName = FormSettings.name;

    constructor(props) {
        super(props);
        this.state = {
            formCredentials: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newFormCredentials = this.state.formCredentials;
        newFormCredentials[e.target.name] = e.target.value;
        this.setState({ formCredentials: newFormCredentials });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let formCredentials = this.state.formCredentials;

        fetch('AdminSettings/UpdateFormSettingsData', {
            method: 'POST',
            body: JSON.stringify(formCredentials),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (data === "Saved") {
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        )
    }

    render() {
        let toEmail;

        let isFormCredentialsSet = false;
        if (this.state.formCredentials != null) {
            let formCredentials = this.state.formCredentials;
            toEmail = formCredentials.toEmail;

            isFormCredentialsSet = true;
        }

        let toEmailInput = isFormCredentialsSet ?
            <TagsByInput
                tags={toEmail}
                tagUpdate={this.handleChange}
                name='toEmail'
                isRequired={true}
                allowDuplicates={false}
                inputType='email'
            /> : "";

        return (
            <div className='admin-settings--form'>
                <form onSubmit={this.handleSubmit}>
                    <div className='grid-wrapper'>
                        <div className='dual-grid--offset'>
                            <div className='dual-grid__1-2 form-title'>
                                <h3>Form</h3>
                            </div>

                            <label>To Email: </label>
                            {/*<input name='toEmail' type='email' defaultValue={toEmail} onChange={this.handleChange} required multiple />*/}
                            {toEmailInput}

                            <div className='dual-grid__1-2'>
                                <button type='submit' className='form-button'>Save</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminSettings/GetFormSettingsData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            formCredentials: data
        });
    }
}

export default FormSettings;
